import axios from "axios";
import rolloutServiceConfig from "./rolloutServiceConfig";
class rolloutService {
    getRolloutSettings = (params) => axios.get(`${rolloutServiceConfig.getRolloutSettings}`,{params});
    setRolloutSettings = (payload) => axios.post(`${rolloutServiceConfig.setRolloutSettings}`, payload);
}
const instance = new rolloutService();
export default instance;
